module.exports = __webpack_public_path__ + "img/img.91ae676e.png";